import { Type } from '@angular/core';
import { Route, Routes } from '@angular/router';

import { BaseRouteComponent } from '../components';
import { MenuItemResolver } from '../resolvers';
import { AuthGuard } from '../../auth';
import { DiscardChangesGuard } from '../guards';

export function singleRoute(rootComponent: Type<any>): Routes {
  return [
    {
      path: '',
      runGuardsAndResolvers: 'always',
      resolve: { menuItem: MenuItemResolver },
      canActivate: [AuthGuard, DiscardChangesGuard],
      component: rootComponent,
    },
  ];
}

export function extraRoute(path: string, rootComponent: Type<any>): Route {
  return {
    path,
    runGuardsAndResolvers: 'always',
    resolve: { menuItem: MenuItemResolver },
    canActivate: [AuthGuard, DiscardChangesGuard],
    component: rootComponent,
  };
}

export function searchEditRoutes(searchComponent: Type<any>, editComponent: Type<any>): Routes {
  return searchCreateEditRoutes(searchComponent, editComponent, editComponent);
}

export function searchCreateEditRoutes(
  searchComponent: Type<any>,
  createComponent: Type<any>,
  editComponent: Type<any>,
): Routes {
  return [
    {
      path: '',
      runGuardsAndResolvers: 'always',
      resolve: { menuItem: MenuItemResolver },
      component: BaseRouteComponent,
      canActivate: [AuthGuard, DiscardChangesGuard],
      children: [
        { path: '', component: searchComponent },
        { path: 'Create', component: createComponent },
        { path: 'Edit/:id', component: editComponent },
      ],
    },
  ];
}

export function searchEditReportRoutes(
  searchComponent: Type<any>,
  editComponent: Type<any>,
  reportComponent: Type<any>,
  report2Component: Type<any>,
): Routes {
  return searchCreateEditReportRoutes(searchComponent, editComponent, editComponent, reportComponent, report2Component);
}

export function searchCreateEditReportRoutes(
  searchComponent: Type<any>,
  createComponent: Type<any>,
  editComponent: Type<any>,
  reportComponent: Type<any>,
  report2Component: Type<any>,
): Routes {
  return [
    {
      path: '',
      runGuardsAndResolvers: 'always',
      resolve: { menuItem: MenuItemResolver },
      component: BaseRouteComponent,
      canActivate: [AuthGuard, DiscardChangesGuard],
      children: [
        { path: '', component: searchComponent },
        { path: 'Create', component: createComponent },
        { path: 'Edit/:id', component: editComponent },
        { path: 'Report', component: reportComponent },
        { path: 'Report2', component: report2Component },
      ],
    },
  ];
}
